export const CATEGORIES = ["materials", "tools", "gas", "labor", "advertising", "other"];

export const CATEGORY_COLORS = {
  materials: "#F26522",
  tools: "#38BDF8",
  gas: "#FACC15",
  labor: "#A78BFA",
  advertising: "#34D399",
  other: "#94A3B8",
};

export const money = (n) =>
  Number(n || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });

export const todayISO = () => {
  const d = new Date();
  const pad = (x) => String(x).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const currentMonth = () => todayISO().slice(0, 7);

export const fmtMMDDYYYY = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return `${m}/${d}/${y}`;
};
